import React, {Fragment, useEffect, useState} from "react";
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";

import CountryChart from "../Charts/CountryChart";
import CountryTop from "../Charts/CountryTop";
import EmptyCard from "../../hoc/EmptyCard";
import Empty from "./Empty";
import classes from "./styles.module.css";

export default withAuth(({token}) => {
    const [chartData, setChartData] = useState([]);
    const [tableData, setTableData] = useState([]);

    const parseMoney = (v) => {
        if (typeof v !== 'string') return Number(v) || 0;
        return Number(v.replace(/[\s$,]/g, "")) || 0;
    };

    useEffect(() => {
        const api = new Api({token});

        Promise.all([
            api.getCountryMapChart(),
            api.getCountryTopData(),
        ]).then(([map, top]) => {
            setTableData(Array.isArray(top) ? top : []);

            // Если в карте нет строк — строим из top
            let preparedMap = Array.isArray(map) ? map : [];
            if (!(preparedMap.length > 1) && Array.isArray(top) && top.length > 0) {
                preparedMap = [
                    ['Country', 'Transactions', 'SUM'],
                    ...top.map(row => [
                        row[0],
                        Number(row[2]) || 0,
                        parseMoney(row[1])
                    ]),
                ];
            }

            setChartData(preparedMap);
        });
    }, [token]);

    return (
        <EmptyCard>
            <div className={classes.Container}>
                {chartData.length > 1 && tableData.length > 0 ? (
                    <Fragment>
                        <div className={classes.ChartColumn}>
                            <CountryChart data={chartData}/>
                        </div>
                        <div className={classes.TableColumn}>
                            <CountryTop data={tableData}/>
                        </div>
                    </Fragment>
                ) : (
                    <Empty/>
                )}
            </div>
        </EmptyCard>
    );
});



// WEBPACK FOOTER //
// ./src/Components/CountryWidget/index.js